import React from "react";
import { Link } from "react-router-dom";
import "./Card.css"

export default function Card({
  name,
  background_image,
  genres,
  id,
  rating,
  platforms,
 /*  screenshots */
}) {
  return (
    <div className="containerCard">
    <Link className="linkCard" to={"/home/" + id}>
      {/* <div className="container-imgCard"> */}
      <img className="imgCard" src={background_image} alt="fondo de game" widht="250px" height="250px" />
      {/* </div> */}
      <div className="containerTitulo">
      <h2 className="nameTitulo">{name}</h2>
      </div>
     {/*  {screenshots.map((el) =>{
        return <img src={el.image} key={el.image} widht="250px" height="250px" alt="not found"/>
      })} */}
      {/* mapeo y muestro las plataformas */}
      <div className="containerPlatform">
          <p className="PCard"> Plataformas:  </p>
            {platforms?.map((g) => {
              return (
                <div className="letra-platforms" key={g.name}>
                  {"|"}{g.name}{"|"}
                </div>
              );
          })}
      </div>
      {/*  mapeo y muestro los genes */}
      <div className="containerPgenres">
        <p className="PCard"> Generos:  </p>
            {genres?.map((g) => {
              return (
                <div className="letra-genres" key={g.name}>
                  {"|"}{g.name}{"|"}
                </div>
              );
            })}
    
      </div>
      
      <div className="footerCard">
      <h4 className="rating">Rating: {rating}</h4>
      </div>
      
     
      </Link>
    </div>
  );
}